
























































































































































import Vue from "vue";
import data from "@/data/userData";
import Dan from "@/models/Dan";
import User from "@/models/User";

export default Vue.extend({
  created() {
    const initialData = data;
    Dan.insert({ data: initialData });
  },

  computed: {
    dans(): Dan[] {
      return Dan.query().orderBy("id", "desc").get() || [];
    },

    users(): User[] {
      return (
        this.dans
          ?.map((dan: Dan) => {
            dan.data?.forEach((data: User) => {
              data.danclass = dan.danclass;
            });
            return dan.data;
          })
          ?.reduce((result, item) => {
            return result.concat(item);
          }) || []
      );
    },

    presidents(): User[] {
      return (
        this.users?.filter((user: User) => {
          return user.designation?.includes("President");
        }) || []
      );
    },

    vicepresidents(): User[] {
      return (
        this.users
          ?.filter((user: User) => {
            return user.designation?.includes("Vice President");
          })
          ?.sort((a, b) => a.adminposition - b.adminposition) || []
      );
    },

    admins(): User[] {
      return (
        this.users
          ?.filter((user: User) => {
            return (
              user.adminposition > 0 &&
              !user.designation?.includes("President") &&
              !user.designation?.includes("Vice President")
            );
          })
          ?.sort((a, b) => a.adminposition - b.adminposition) || []
      );
    },

    scis(): User[] {
      return (
        this.users
          ?.filter((user: User) => {
            return user.designation?.includes("State Chief Instructor");
          })
          ?.sort((a, b) => a.sciposition - b.sciposition) || []
      );
    },

    itas(): User[] {
      return (
        this.users?.filter((user: User) => {
          return user.designation?.includes(
            "Information Technology Administrator"
          );
        }) || []
      );
    },
  },

  methods: {
    resetScrollToContainerTop(): void {
      const container: HTMLElement | null =
        document?.querySelector(".container");
      if (container) {
        container.scrollTop = 0;
      }
    },

    getImgUrl(pic: string): any {
      return require(`../assets/images/${pic}`);
    },

    getAdminDesignations(designations: string[]): any {
      return designations.filter((designation: string) => {
        return designation != "State Chief Instructor";
      });
    },
  },

  mounted() {
    this.resetScrollToContainerTop();
  },
});
